import { useSession } from "../session/useSession";

/**
 * Barra horizontal con los 5 pasos del flujo. Cada tab puede estar:
 *   - active:    el paso actual (resaltado)
 *   - done:      ya tiene respuesta del backend
 *   - reachable: ya visible o se puede llegar (no bloqueado)
 *   - locked:    no se puede clickear (paso futuro sin completar el anterior)
 *
 * Patrón de "render según estado", similar a LoginGate pero por tab.
 */

const STEPS = [
  { id: 1, label: "Descubrimiento", icon: "🔍" },
  { id: 2, label: "Especificaciones", icon: "📋" },
  { id: 3, label: "Opciones", icon: "🛒" },
  { id: 4, label: "Comparación", icon: "⚖️" },
  { id: 5, label: "Dónde comprar", icon: "🛍️" },
];

export function Stepper() {
  const { step, formData, responses, goToStep } = useSession();

  // Reglas de completitud (idénticas a las que vimos para el v1)
  const completion = {
    1: !!formData.product, // confirmó una categoría
    2: !!responses[2],
    3: !!responses[3],
    4: !!responses[4],
    5: !!responses[5],
  };

  return (
    <nav style={styles.stepper}>
      {STEPS.map((s) => {
        const done = completion[s.id];
        const active = step === s.id;
        // Reachable = done o el actual o un paso ya visitado (id <= step)
        const reachable = done || active || s.id <= step;

        return (
          <button
            key={s.id}
            style={styles.tab(active, done, reachable)}
            onClick={() => reachable && goToStep(s.id)}
            disabled={!reachable}
          >
            <span>{s.icon}</span>
            <span>{s.label}</span>
            {done && <span style={styles.check}>✓</span>}
          </button>
        );
      })}
    </nav>
  );
}

const styles = {
  stepper: {
    display: "flex",
    background: "#fff",
    borderBottom: "1px solid #e8e4ff",
    padding: "0 16px",
    overflowX: "auto",
  },
  tab: (active, done, reachable) => ({
    padding: "14px 12px",
    cursor: reachable ? "pointer" : "not-allowed",
    display: "flex",
    alignItems: "center",
    gap: "6px",
    background: "none",
    border: "none",
    borderBottom: active ? "2px solid #6c63ff" : "2px solid transparent",
    color: active ? "#6c63ff" : done ? "#1a1a2e" : reachable ? "#888" : "#bbb",
    fontSize: "13px",
    fontFamily: "sans-serif",
    whiteSpace: "nowrap",
    transition: "all 0.15s",
    opacity: reachable ? 1 : 0.5,
  }),
  check: {
    color: "#22c55e",
    fontSize: "11px",
  },
};
